// Limits and timings from docs/chat/CONTRACT.md §6–§7. The server enforces
// all of them; the client uses them only for UX hints.

export const CHAT_MAX_MESSAGE_LENGTH = 4096;
export const CHAT_MAX_ATTACHMENTS = 10;
export const CHAT_MAX_FILE_BYTES = 20 * 1024 * 1024;
export const CHAT_ALLOWED_MIME = ["image/jpeg", "image/png", "image/webp"] as const;

/**
 * Фото в чате. Пока на сервере нет хранилища (CHAT_R2_BUCKET_NAME), кнопки
 * камеры/галереи, вставка и перетаскивание фото скрыты — только текст.
 * Включить после настройки бакета: VITE_CHAT_PHOTOS=true. В mock-режиме — всегда.
 */
export const CHAT_PHOTOS_ENABLED =
  import.meta.env.VITE_CHAT_PHOTOS === "true" || import.meta.env.VITE_CHAT_MOCK === "true";
export type ChatAllowedMime = (typeof CHAT_ALLOWED_MIME)[number];

export const CHAT_EDIT_WINDOW_MS = 48 * 60 * 60 * 1000;
export const CHAT_DELETE_WINDOW_MS = 48 * 60 * 60 * 1000;

export const CONVERSATIONS_PAGE_SIZE = 20;
export const MESSAGES_PAGE_SIZE = 30;
export const MESSAGES_AFTER_PAGE_SIZE = 100;

export const TYPING_SEND_INTERVAL_MS = 3000;
export const TYPING_IDLE_MS = 5000;
export const TYPING_DISPLAY_MS = 8000;

export const DELIVERY_DEBOUNCE_MS = 500;
export const READ_DEBOUNCE_MS = 300;
export const SOCKET_ACK_TIMEOUT_MS = 10_000;

/** Show the length counter once the text gets close to the limit. */
export const LENGTH_COUNTER_FROM = 3500;
